module.exports = __webpack_public_path__ + "static/media/opera-neon_256x256.70815baf.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/browser-logos/src/opera-neon/opera-neon_256x256.png
// module id = 2875
// module chunks = 0